/// <reference path="../../../../../typings/index.d.ts" />

module Meevo.ConfigurePayrollSettings {
    export class ConfigurePayrollSettingsController {

        private payrollFrequencyExclusionList: [Meevo.Model.PayrollFrequencyEnum] = [Meevo.Model.PayrollFrequencyEnum.SemiMonthly];
        private availableDates: [string];

        static $inject = [
            "$scope",
            "$mdDialog",
            "$mdSidenav",
            "$translate",
            "settings",
            'serviceProjections',
            'retailProjections',
        ];

        constructor(
            private $scope: ng.IScope,
            private $mdDialog: angular.material.IDialogService,
            protected $mdSidenav: ng.material.ISidenavService,
            private $translate: angular.translate.ITranslateService,
            protected settings: Meevo.Model.CompensationSettings,
            protected serviceProjections: Meevo.Model.IDateRange[],
            protected retailProjections: Meevo.Model.IDateRange[]

        ) {

        }

        confirm = (answer: boolean) => {
            this.$mdDialog.hide(answer)
        }

        enumValueOf(value: number) {
            return Meevo.Model.PayrollFrequencyEnum[value] || Meevo.Model.WeekdayNameEnum[value]
        }

    }

    angular.module("meevo")
        .controller("meevo.configurePayrollSettings.configurePayrollSettingsController", ConfigurePayrollSettingsController);
}